// extracted by mini-css-extract-plugin
module.exports = {"customCheckbox":"checkbox_customCheckbox__qiCOn"};